import React from 'react';

interface PropTypes {
  children: React.ReactNode;
}

export function FormGroup(props: PropTypes) {
  return <div className='d-flex flex-column gap-3'>{props.children}</div>;
}
